import angular from 'angular'
// 合同录入编辑页面
import contractInvoiceEditCtrl from './contractInvoiceEditCtrl'
import { contractManagement, contractEntering, collection, management } from 'redevConfig'

const list = (contractManagement && contractManagement.list) || ''
const edit = (contractManagement && contractManagement.edit) || ''
const invoiceCollectionDetail = (collection && collection.detail) || ''
const invoiceManagementDetail = (management && management.detail) || ''
const contractEnteringEdit = (contractEntering && contractEntering.edit) || ''

const listPage = list ? require(`redevelopment/input/contractManagement/${list.templateName}`) : require('./view/list.html')
const contractManageListCtrl = list ? require(`redevelopment/input/contractManagement/${list.controllerName}`) : require('./contractManageListCtrl.js')
const editPage = edit ? require(`redevelopment/input/contractManagement/${edit.templateName}`) : require('./view/edit.html')
const contractManageEditCtrl = edit ? require(`redevelopment/input/contractManagement/${edit.controllerName}`) : require('./contractManageEditCtrl.js')
const imagePage = contractEnteringEdit ? require(`redevelopment/input/contractEntering/${edit.templateName}`) : require('../contractEntering/view/edit.html')
const invoiceCollectionDetailPage = invoiceCollectionDetail ? require(`redevelopment/input/collection/${invoiceCollectionDetail.templateName}`) : require('../../inputInvoice/collection/view/invoiceCollectionDetail.html')
const invoiceManagementDetailPage = invoiceManagementDetail ? require(`redevelopment/input/management/${invoiceManagementDetail.templateName}`) : require('../../inputInvoice/management/view/managementDetail.html')
export default angular
    .module('input.electronImage.contractManagement', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.electronImage.contractManagement', {
            url: '/contractManagement',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'input.electronImage.contractManagement.list',
            title: '合同管理',
        })
        $stateProvider.state('input.electronImage.contractManagement.list', {
            url: '/list',
            template: listPage,
            controller: 'contractManageListCtrl',
        })
        // 编辑和详情公用controller mode取值edit
        $stateProvider.state('input.electronImage.contractManagement.edit', {
            url: '/edit/:contractId/:mode',
            template: editPage,
            controller: 'contractManageEditCtrl',
            title: '编辑',
        })
        $stateProvider.state('input.electronImage.contractManagement.edit.image', {
            views: {
                '@input.electronImage.contractManagement': {
                    template: imagePage,
                    controller: 'contractEnteringEditCtrl',
                },
            },
            url: '/image/:contractId/:tabIndex/:readonly',
            title: '合同影像',
        })
        // 编辑和详情公用controller mode取值readonly
        $stateProvider.state('input.electronImage.contractManagement.detail', {
            url: '/detail/:contractId:/:mode',
            template: editPage,
            controller: 'contractManageEditCtrl',
            title: '详情',
        })
        // 合同影像进入合同录入的编辑页面的readonly
        $stateProvider.state('input.electronImage.contractManagement.detail.image', {
            views: {
                '@input.electronImage.contractManagement': {
                    template: imagePage,
                    controller: 'contractEnteringEditCtrl',
                },
            },
            url: '/image/:contractId/:tabIndex/:readonly',
            title: '合同影像',
        })
        // 由合同详情进入发票收集详情
        $stateProvider.state('input.electronImage.contractManagement.detail.invoice', {
            url: '/invoice/:object',
            views: {
                '@input.electronImage.contractManagement': {
                    template: invoiceCollectionDetailPage,
                    controller: 'invoiceCollectionDetailCtrl',
                },
            },
            title: '发票详情',
        })
        // 由合同详情进入校对通过的进入发票管理详情
        $stateProvider.state('input.electronImage.contractManagement.detail.invoiceDetail', {
            url: '/invoiceDetail/:object',
            views: {
                '@input.electronImage.contractManagement': {
                    template: invoiceManagementDetailPage,
                    controller: 'managementDetailCtrl',
                },
            },
            title: '发票详情',
        })
        // 由合同编辑进入发票收集详情
        $stateProvider.state('input.electronImage.contractManagement.edit.invoice', {
            url: '/invoice/:object',
            views: {
                '@input.electronImage.contractManagement': {
                    template: invoiceCollectionDetailPage,
                    controller: 'invoiceCollectionDetailCtrl',
                },
            },
            title: '发票详情',
        })
        // 由合同编辑进入发票管理详情
        $stateProvider.state('input.electronImage.contractManagement.edit.invoiceDetail', {
            url: '/invoiceDetail/:object',
            views: {
                '@input.electronImage.contractManagement': {
                    template: invoiceManagementDetailPage,
                    controller: 'managementDetailCtrl',
                },
            },
            title: '发票详情',
        })
        // 导入和扫描补录的发票编辑时进去合同录入的编辑页面
        $stateProvider.state('input.electronImage.contractManagement.edit.editinvoice', {
            url: '/editinvoice/:contractId/:tabIndex/:invoiceId',
            views: {
                '@input.electronImage.contractManagement': {
                    template: imagePage,
                    controller: 'contractEnteringEditCtrl',
                },
            },
            title: '编辑发票',
        })
    }])
    .controller('contractManageListCtrl', contractManageListCtrl.default)
    .controller('contractManageEditCtrl', contractManageEditCtrl.default)
    .controller('contractInvoiceEditCtrl', contractInvoiceEditCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractManagement/index.js